<script setup>
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import TagList from "./tag-list.vue";
import {ref, watch, nextTick, onMounted} from 'vue'
import helpers from "@/lib/helpers";

const tagac = ref()

const props = defineProps({
  url: String,
  value: Array,
  tagsUrl: String,
  read: String,
  write: String
})

const emits = defineEmits(['input'])

const tags = ref([])
const availableTags = ref([])
const newtag = ref('')

watch(tags, (v) => emits('input', v))
if (props.value)
  watch(props.value, (v) => tags.value = v)

const refresh = (nofetch) => {
  if (props.read && !helpers.can(props.read))
    return

  availableTags.value = []
  const url = props.url ? props.url + '/available' : props.tagsUrl

  helpers.asyncAction(url, 'GET', {noload: true}).then((v) => {
    availableTags.value = v
  })

  if (!nofetch && props.url) {
    helpers.asyncAction(props.url, 'GET', {noload: 'tags'}).then((v) => {
      tags.value = v
    })
  }
}

watch(() => props.value, (v) => {
  tags.value = v
  refresh(true)
})

onMounted(() => {
  if (!props.url || props.value) {
    tags.value = props.value
    refresh(true)
  } else
    refresh()
})


const add = () => {
  if (props.url) {
    if (newtag.value) {
      helpers.asyncAction(props.url, 'POST', {
        noload: 'tags',
        data: {
          tag: newtag.value
        }
      }).then(() => {
        nextTick(() => {
          newtag.value = ''
          tagac.value.$refs.input.focus()
        })
        refresh()
      })
    }
  } else {
    const tag = validate(newtag.value)
    if (!tag) {
      newtag.value = ''
      helpers.alert('Tag must be between 2 and 12 character, letters, number, and/or -')
      return false
    }
    tags.value = tags.value || []

    if (!tags.value.find(t => t.tag === tag))
      tags.value.push({tag})

    nextTick(() => {
      newtag.value = ''
      tagac.value.$refs.input.focus()
    })
  }
}

const validate = (tag) => {
  if (tag.length >= 2 && tag.length <= 12) {
    if (tag.search(/^[a-zA-Z0-9-]+$/) !== -1)
      return tag.toUpperCase()
  }

  return null
}

const tagDelete = (tag) => {
  if (props.url) {
    helpers.asyncAction(tag._links.delete_url.href, tag._links.delete_url.method, {noload: 'tags'}).then(() => {
      refresh()
    })
  } else
    tags.value = tags.value.filter((t) => t !== tag)
}
</script>

<template>
  <b-overlay :show="$store.getters.activity_alt('tags')" class="m-n2 p-2 mb-0" v-if="!read || can(read)"
             spinner-variant="danger" opacity="0.4">
    <div class="h6" style="min-height: 30px">
      <div class="flex-fill d-block">
        <tag-list :tags="tags" tag-class="mb-2 mr-2 py-2">
          <template #append="{tag}">
            <b-link active-class="xbtn" class="xbtn" @click="tagDelete(tag)">
              <font-awesome-icon icon="fa-regular fa-circle-xmark" class="mr-2"/>
            </b-link>
          </template>
        </tag-list>
      </div>
      <div v-if="!write || can(write)">
        <b-input-group>
          <vue-bootstrap-autocomplete ref="tagac" @keyup.enter.stop="add" class="flex-fill"
                                      input-class="form-control form-enter-ignore form-change-ignore" show-on-focus
                                      size="sm" autofocus v-model="newtag" :data="availableTags"/>

          <b-input-group-append>
            <b-button size="sm" variant="outline-primary" class="px-4" @click="add()">Add</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
  </b-overlay>
</template>

<style scoped>
.xbtn {
  color: #ffffff !important
}
</style>